import axios from 'axios';

import ServiciosSeleccionar from '../types/ServiciosSeleccionar';


async function GuardarServiciosPlan(prmIdPlan: number, prmServiciosPlan: ServiciosSeleccionar[]) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_servicios_plan"
    
    // Transformo prmServiciosPlan a un objeto que tenga "id": y el valor pero solo de solo los ids

    const serviciosIds = prmServiciosPlan.map(item => ({id: item.id}));
    
    const DataPayload = {
        "usuario": "mpatti",
        "clave": "all2GetHer_!",
        "id_plan": prmIdPlan,
        "servicios": serviciosIds
    };

    try {
        const response = await axios.post(url, DataPayload);
        return response.data;

    } catch (error) {
        return error;
    }
};

export default GuardarServiciosPlan;